// extracted by mini-css-extract-plugin
module.exports = {"link":"_e475be1","linkIcon":"_188eb3b"};